module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_6.eff821fc.gif";